import React, { useEffect, useState } from 'react'

import { shape, object } from 'prop-types'

import ModelCardActionButtons from './ModelCardActionButtons'

// The action buttons mount once the card first nears the viewport. The visibility state lives here
// rather than in ModelCard so a card scrolling into view re-renders only this subtree, not the image,
// tags and price of the card around it.
function ModelCardLazyActionButtons({ cardRef, ...props }) {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const cardElement = cardRef.current
    if (!cardElement || isVisible) {
      return undefined
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setIsVisible(true)
        }
      },
      {
        rootMargin: '50px',
        threshold: 0.1,
      }
    )

    observer.observe(cardElement)

    return () => observer.disconnect()
  }, [cardRef, isVisible])

  if (!isVisible) {
    return null
  }

  return <ModelCardActionButtons {...props} />
}

ModelCardLazyActionButtons.propTypes = {
  cardRef: shape({ current: object }).isRequired,
}

export default ModelCardLazyActionButtons
